import {http} from '@/http'

export default {
  list() {
    return http.get('/api/v1/price-types')
  },
  update(id, data) {
    return http.put(`/api/v1/price-types/${id}`, data)
  },
  simulate(formula, baseAmount) {
    return http.get('/api/v1/price-types/simulate', {params: {formula, base_amount: baseAmount}})
  }
}
